import { observer } from 'mobx-react';
import React from 'react';
import { AnalyticsTrigger, EqualHeight, Heading, Icon, OptionCard, OptionCardContent, Separator, Tag } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import { StartingCompanyPackage } from './StartingCompanyCalculator';

interface StartingCompanySelectPackageCardProps {
  card: StartingCompanyPackage;
  checkedPackages: string[];
  onChange: (pck: string) => void;
}

const StartingCompanySelectPackageCard: React.FC<StartingCompanySelectPackageCardProps> = ({ card, onChange, checkedPackages }) => {
  const translate = React.useContext(TranslationsContext).translate;
  return (
    <AnalyticsTrigger
      trigger={{
        id: `Card - ${card.value} - ${!checkedPackages.includes(card.value) ? 'Check' : 'Uncheck'}`,
        callback: 'onChange',
      }}
    >
      <OptionCard
        id={card.value}
        labelText={card.title}
        inputType="checkbox"
        padding="medium"
        checked={checkedPackages.includes(card.value)}
        onChange={() => onChange(card.value)}
        className="text-center"
        background="neutral-bg-level-1"
      >
        <OptionCardContent>
          <div>
            <Icon align="middle" modifiers={`#${card.icon}`} size="lg" />
          </div>
          <Separator color="invisible" spacing="xxsmall" />
          <EqualHeight group="card-text">
            <Heading className="text-bold h5" element="h2">
              {card.title}
            </Heading>
          </EqualHeight>
          <Separator color="invisible" spacing="xxsmall" />
          <strong>{translate('starting-company.price', { price: card.price })}</strong>
          {!!card.offer && (
            <>
              <Separator color="invisible" spacing="xxsmall" />
              <p className="text-small text-dark">{translate('starting-company.offer')}</p>
              <div>
                <Tag size="tiny" text={card.offer.tag} purpose="campaign-3" />
              </div>
              <p className="text-small">{card.offer.text}</p>
            </>
          )}
        </OptionCardContent>
      </OptionCard>
    </AnalyticsTrigger>
  );
};

export default observer(StartingCompanySelectPackageCard);
